import React, { useEffect, useState } from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import { Field, Form, reduxForm } from 'redux-form';
import { __ } from '../../core/utils';
import { listPossibleTags } from '../../redux/actions/general';
import { enableAutosave } from '../../redux/actions/general/autosave';
import Tags from '../../components/Tags';
import styles from '../../styles/flyouts/files/FileFlyout.scss';

const FORM_NAME = 'files.tags';

const FileTags = ({ collapsed, data, handleSubmit }) => {
  const [possibleTags, setPossibleTags] = useState([]);

  useEffect(() => {
    enableAutosave(FORM_NAME);
  }, []);

  useEffect(() => {
    if (!data.project_id) {
      return;
    }

    listPossibleTags('project', data.project_id).then(({ response }) => {
      setPossibleTags(response.data);
    });
  }, [data.project_id]);

  return (
    <Form
      onSubmit={handleSubmit}
      className={classNames(
        styles.sectionContent,
        styles.tagsContent,
        collapsed && styles.collapsed,
      )}
    >
      <Field
        key={data.id}
        name='tags'
        component={Tags}
        label={__('Tags')}
        options={_.uniq([...(data.tags || []), ...possibleTags])}
      />
    </Form>
  );
};

export default reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(FileTags);
